var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87484 9.17501V9.19742M5.60039 5.05534C5.60039 4.33788 6.17123 3.75626 6.87539 3.75626C7.57955 3.75626 8.15039 4.33788 8.15039 5.05534C8.15039 5.7728 7.57955 6.35442 6.87539 6.35442C6.87539 6.35442 6.87484 6.74217 6.87484 7.22047M11.9754 6.62501C11.9754 9.44166 9.69204 11.725 6.87539 11.725C4.05874 11.725 1.77539 9.44166 1.77539 6.62501C1.77539 3.80836 4.05874 1.52501 6.87539 1.52501C9.69204 1.52501 11.9754 3.80836 11.9754 6.62501Z",
    stroke: "#AE0000",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.7b93de4f8b43cb74b8b18763a03cc2b8.svg";
export { ForwardRef as ReactComponent };